/** Spanish for one part of the app (ADR 0325); see index.ts for the house style. */
export const contacts: Readonly<Record<string, string>> = {
  // The customer page
  "Contact not found": "Contacto no encontrado",
  "They may have been removed.": "Puede que lo hayan eliminado.",
  Contact: "Contacto",
  "this customer": "este cliente",
  "Contact Info": "Datos de contacto",
  "First name": "Nombre",
  "Last name": "Apellido",
  Company: "Empresa",
  Cell: "Celular",
  "Alternate phone": "Teléfono alterno",
  "Whose? e.g. spouse": "¿De quién? p. ej. cónyuge",
  "Other numbers": "Otros números",
  "Mailing Address": "Dirección postal",
  "Street View ↗": "Ver en Street View ↗",
  City: "Ciudad",
  State: "Estado",
  Zip: "Código postal",
  "Contact Since": "Contacto desde",
  "+ New job for this contact": "+ Nuevo trabajo para este contacto",
  "No jobs yet": "Aún no hay trabajos",
  "Create the first one above.": "Crea el primero arriba.",
  "No address": "Sin dirección",
  "Created {when}": "Creado {when}",
  "Activity — All Jobs": "Actividad — Todos los trabajos",
  "latest {when}": "último {when}",
  "No activity yet": "Aún no hay actividad",
  "Notes and status changes from every job for this contact will collect here.":
    "Aquí se juntan las notas y los cambios de estado de todos los trabajos de este contacto.",
  // The kind of each activity row (KIND_LABEL)
  STEP: "PASO",
  STATUS: "ESTADO",
  NOTE: "NOTA",
  Someone: "Alguien",
  "Status → {stage}": "Estado → {stage}",
  "No jobs yet — figures appear once this contact has one.":
    "Aún no hay trabajos — las cifras aparecen cuando este contacto tenga uno.",
  "Total revenue": "Ingresos totales",
  "Total jobs": "Trabajos totales",
  "Approved jobs": "Trabajos aprobados",
  Conversion: "Conversión",
  "Delete {name}?": "¿Eliminar a {name}?",
  "They have no jobs, so nothing else goes with them. This cannot be undone.":
    "No tiene trabajos, así que no se elimina nada más. Esto no se puede deshacer.",
  "Deleting…": "Eliminando…",
  "Delete this customer": "Eliminar este cliente",
  "They have no jobs. Useful for a duplicate entered twice.":
    "No tiene trabajos. Útil para un duplicado ingresado dos veces.",

  // Flags across the top of the customer page
  "Blacklisted — do not work with": "En lista negra — no trabajar con él",
  "No automated contact": "Sin contacto automático",
  "1 lost job": "1 trabajo perdido",
  "{n} lost jobs": "{n} trabajos perdidos",
  "No automated email or text": "Sin email ni mensaje automático",
  Blacklist: "Lista negra",

  // The customer list
  Customer: "Cliente",
  Address: "Dirección",
  "Latest Job": "Último trabajo",
  "No customers": "No hay clientes",
  "No customers match the current filters.":
    "Ningún cliente coincide con los filtros.",

  // Warnings before a lead is saved
  "Possible duplicate": "Posible duplicado",
  "this customer may already be in the system:":
    "este cliente puede que ya esté en el sistema:",
  "no address": "sin dirección",
  "no phone": "sin teléfono",
  "Add job to this customer": "Agregar trabajo a este cliente",
  "No, this is a different person — create a new customer":
    "No, es otra persona — crear un cliente nuevo",
  "Are you sure?": "¿Seguro?",
  "{name} already has a job still open. Do you want to create another job for them?":
    "{name} ya tiene un trabajo abierto. ¿Crear otro trabajo para este cliente?",
  "{name} already has {n} jobs still open. Do you want to create another job for them?":
    "{name} ya tiene {n} trabajos abiertos. ¿Crear otro trabajo para este cliente?",
  "This customer": "Este cliente",
  "Open this job": "Abrir este trabajo",
  "Yes, create another job": "Sí, crear otro trabajo",

  // The New Lead / New Job form
  "Returning customer? Search first": "¿Cliente que regresa? Busca primero",
  "Search existing customers by name, phone, or email…":
    "Buscar clientes por nombre, teléfono o email…",
  "Pick both a date and a time for the inspection, or remove it.":
    "Elige fecha y hora para la inspección, o quítala.",
  "A last name, or a company name — one of them has to be filled in.":
    "Un apellido o un nombre de empresa — hay que llenar uno de los dos.",
  "New Job": "Nuevo trabajo",
  "Adds another job under this customer. Contact details stay shared across all of their jobs.":
    "Agrega otro trabajo a este cliente. Los datos de contacto se comparten entre todos sus trabajos.",
  "Creates the customer and their first job. You're the sales rep unless you say otherwise.":
    "Crea el cliente y su primer trabajo. Tú eres el vendedor salvo que indiques otro.",
  "Create job": "Crear trabajo",
  "Create lead": "Crear prospecto",
  "Change customer": "Cambiar cliente",
  "Only if the customer is a business": "Solo si el cliente es una empresa",
  "Whose is the alternate?": "¿De quién es el alterno?",
  "Spouse, work, mother — anything that helps":
    "Cónyuge, trabajo, mamá — lo que sirva",
  "Lead source": "Fuente del prospecto",
  "Job address (start typing)": "Dirección del trabajo (empieza a escribir)",
  "Job type": "Tipo de trabajo",
  Residential: "Residencial",
  Commercial: "Comercial",
  "Bid type": "Tipo de oferta",
  Retail: "Particular",
  Insurance: "Seguro",
  "Sales rep": "Vendedor",
  "(you)": "(tú)",
};
